// service/Horarios.js
import instance from "../apis/app";
import instanceDownload from "../apis/download";
import { errorDeApi } from "./client";

const Post = async (data) => {
    try {
        const response = await instance.post("/horario", data);
        return response;
    } catch (error) {
        throw error.response;
    }
}

const List = async () => {
    try {
        const response = await instance.get("/horario");
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
}

const Update = async (id, data) => {
    try {
        const response = await instance.put(`/horario/${id}`, data);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
}

const Delete = async (id) => {
    try {
        const response = await instance.delete(`/horario/${id}`);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
}

const GetHorariosPorTaller = async (tallerId) => {
    try {
        const response = await instance.get(`/horario/taller/${tallerId}`);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
}

// 🆕 Obtener historial de cambios de horarios de un taller
const GetHistorialHorariosPorTaller = async (tallerId) => {
    try {
        const response = await instance.get(`/horario/taller/${tallerId}/historial`);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
}

// 🆕 Validar cupos disponibles de un horario
const ValidarCuposDisponibles = async (horarioId) => {
    try {
        const response = await instance.get(`/horario/${horarioId}/cupos`);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
}

// 🆕 Obtener estadísticas de horarios de un taller
const GetEstadisticasHorarios = async (tallerId) => {
    try {
        const response = await instance.get(`/horario/taller/${tallerId}/estadisticas`);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
}

// 🆕 Obtener inscritos de un horario con filtros
const GetInscritosPorHorario = async (horarioId, filtros = {}) => {
    try {
        const params = new URLSearchParams();

        // Agregar parámetros solo si existen
        if (filtros.page) params.append('page', filtros.page);
        if (filtros.limit) params.append('limit', filtros.limit);
        if (filtros.estado) params.append('estado', filtros.estado);
        if (filtros.vigente !== undefined) params.append('vigente', filtros.vigente);
        if (filtros.tipoInscripcion) params.append('tipoInscripcion', filtros.tipoInscripcion);
        if (filtros.sortBy) params.append('sortBy', filtros.sortBy);
        if (filtros.sortOrder) params.append('sortOrder', filtros.sortOrder);

        const queryString = params.toString();
        const url = `/horario/${horarioId}/inscritos${queryString ? `?${queryString}` : ''}`;

        const response = await instance.get(url);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
}

// 🆕 Obtener solo inscritos vigentes de un horario
const GetInscritosVigentes = async (horarioId) => {
    try {
        //limit = 1000 para evitar problemas si hay muchos inscritos
        const response = await instance.get(`/horario/${horarioId}/inscritos?limit=300`);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
}

// 🆕 Exportar inscritos de un horario
const ExportarInscritosPorHorario = async (horarioId, filtros = {}) => {
    try {
        const params = new URLSearchParams();

        if (filtros.estado) params.append('estado', filtros.estado);
        if (filtros.vigente !== undefined) params.append('vigente', filtros.vigente);
        if (filtros.sortBy) params.append('sortBy', filtros.sortBy);
        if (filtros.sortOrder) params.append('sortOrder', filtros.sortOrder);

        const queryString = params.toString();
        const url = `/horario/${horarioId}/inscritos/exportar${queryString ? `?${queryString}` : ''}`;

        const response = await instance.get(url);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
}

// ✅ REFACTORIZADO - Exportar inscritos a CSV usando instanceDownload
const ExportarInscritosCSV = async (horarioId, filtros = {}) => {
    try {
        const params = new URLSearchParams();
        
        if (filtros.estado) params.append('estado', filtros.estado);
        if (filtros.vigente !== undefined) params.append('vigente', filtros.vigente);
        if (filtros.tipoInscripcion) params.append('tipoInscripcion', filtros.tipoInscripcion);
        if (filtros.sortBy) params.append('sortBy', filtros.sortBy);
        if (filtros.sortOrder) params.append('sortOrder', filtros.sortOrder);
        
        const queryString = params.toString();
        const url = `/horario/${horarioId}/inscritos/export/csv${queryString ? `?${queryString}` : ''}`;
        
        // ✅ Usar instanceDownload con responseType blob
        const response = await instanceDownload.get(url, {
            responseType: 'blob'
        });

        // Crear blob y descargar
        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        
        // Obtener nombre del archivo del header
        const contentDisposition = response.headers['content-disposition'];
        let filename = `inscritos-${Date.now()}.csv`;
        
        if (contentDisposition) {
            const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '');
            }
        }
        
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        
        return {
            success: true,
            message: 'CSV descargado exitosamente',
            filename
        };
    } catch (error) {
        console.error('Error exportando CSV:', error);
        throw error.response?.data || error;
    }
}

// ✅ REFACTORIZADO - Exportar inscritos a Excel usando instanceDownload
const ExportarInscritosExcel = async (horarioId, filtros = {}) => {
    try {
        const params = new URLSearchParams();
        
        if (filtros.estado) params.append('estado', filtros.estado);
        if (filtros.vigente !== undefined) params.append('vigente', filtros.vigente);
        if (filtros.tipoInscripcion) params.append('tipoInscripcion', filtros.tipoInscripcion);
        if (filtros.sortBy) params.append('sortBy', filtros.sortBy);
        if (filtros.sortOrder) params.append('sortOrder', filtros.sortOrder);
        
        const queryString = params.toString();
        const url = `/horario/${horarioId}/inscritos/export/excel${queryString ? `?${queryString}` : ''}`;
        
        // ✅ Usar instanceDownload con responseType blob
        const response = await instanceDownload.get(url, {
            responseType: 'blob'
        });

        // Crear blob y descargar
        const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        
        // Obtener nombre del archivo del header
        const contentDisposition = response.headers['content-disposition'];
        let filename = `inscritos-${Date.now()}.xlsx`;
        
        if (contentDisposition) {
            const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '');
            }
        }
        
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        
        return {
            success: true,
            message: 'Excel descargado exitosamente',
            filename
        };
    } catch (error) {
        console.error('Error exportando Excel:', error);
        throw error.response?.data || error;
    }
}

// 🆕 Función auxiliar para convertir datos a CSV
const ConvertirACSV = (datos) => {
    if (!datos || datos.length === 0) return '';

    const headers = Object.keys(datos[0]);
    const csvRows = [];

    // Headers
    csvRows.push(headers.join(','));

    // Data
    for (const row of datos) {
        const values = headers.map(header => {
            const value = row[header] !== null && row[header] !== undefined ? row[header] : '';
            // El CSV escapa comillas duplicándolas, no con backslash: con \" el
            // campo quedaba mal cerrado y corría las columnas de esa fila.
            let texto = '' + value;
            // Evita que Excel ejecute como fórmula una celda que parte con = + - @
            if (/^[=+\-@\t\r]/.test(texto)) texto = `'${texto}`;
            return `"${texto.replace(/"/g, '""')}"`;
        });
        csvRows.push(values.join(','));
    }

    return csvRows.join('\r\n');
}

// 🆕 Función auxiliar para descargar CSV
const DescargarCSV = (contenido, nombreArchivo) => {
    // Agregar BOM para compatibilidad con Excel y caracteres especiales
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + contenido], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', nombreArchivo);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Limpiar el objeto URL
    setTimeout(() => URL.revokeObjectURL(url), 100);
}

// 🆕 Función completa para exportar y descargar CSV de inscritos
const ExportarYDescargarInscritos = async (horarioId, filtros = {}) => {
    try {
        const response = await ExportarInscritosPorHorario(horarioId, filtros);

        if (response.success && response.data.inscritos.length > 0) {
            const csvContent = ConvertirACSV(response.data.inscritos);
            const nombreHorario = response.data.horario.nombre.replace(/[^a-z0-9]/gi, '_');
            const fecha = new Date().toISOString().split('T')[0];
            const nombreArchivo = `inscritos_${nombreHorario}_${fecha}.csv`;

            DescargarCSV(csvContent, nombreArchivo);

            return {
                success: true,
                message: 'Archivo descargado exitosamente',
                totalInscritos: response.data.totalInscritos
            };
        } else {
            return {
                success: false,
                message: 'No hay inscritos para exportar'
            };
        }
    } catch (error) {
        throw error;
    }
}

export default {
    Post,
    List,
    Update,
    Delete,
    GetHorariosPorTaller,
    GetHistorialHorariosPorTaller,
    ValidarCuposDisponibles,
    GetEstadisticasHorarios,
    GetInscritosPorHorario,
    GetInscritosVigentes,
    ExportarInscritosPorHorario,
    ExportarInscritosCSV,
    ExportarInscritosExcel,
    ConvertirACSV,
    DescargarCSV,
    ExportarYDescargarInscritos
};
